import { render } from "./index.vue?vue&type=template&id=babb9786&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=babb9786&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-babb9786"

export default script